import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { transferPlate } from '../requests/plateTransfer.request';
import { clientRegistrationSummaryKey } from '../queries/plateRegistration.query';
import { plateTransferEligibilityKey } from '../queries/plateTransfer.query';
import { PlateTransferResult, TransferPlateRequest } from '../types/plateTransfer.types';

export const useTransferPlateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    PlateTransferResult | undefined,
    AxiosError,
    { plateId: string; request: TransferPlateRequest }
  >({
    mutationKey: ['plate-transfer'],
    mutationFn: ({ plateId, request }) => transferPlate(plateId, request),
    onSettled: (data, _error, variables) => {
      queryClient.invalidateQueries({ queryKey: plateTransferEligibilityKey(variables.plateId) });
      if (data) {
        queryClient.invalidateQueries({
          queryKey: clientRegistrationSummaryKey(data.fromClientId)
        });
        queryClient.invalidateQueries({ queryKey: clientRegistrationSummaryKey(data.toClientId) });
      }
    }
  });
};
